import type { ComponentSchema } from "../../../../../schema-types";
import { SECTION_STYLE_FIELDS } from "../../_builder-constants";

export const schema: ComponentSchema = {
  type: "categories",
  label: "Categories Grid",
  description: "A grid of all category cards with image and product count.",
  supportedPages: ["home", "categories", "shop"],
  variants: [{ id: "v1", label: "V1 (Image Grid)" }],
  commonFields: [
    { key: "title", label: "Section Title", type: "string" },
    { key: "subtitle", label: "Subtitle", type: "string" },
    {
      key: "columns",
      label: "Columns",
      type: "select",
      options: [
        { label: "2 Columns", value: 2 },
        { label: "3 Columns", value: 3 },
        { label: "4 Columns", value: 4 },
      ],
      default: 4,
    },
    { key: "emptyText", label: "Empty Text", type: "string", default: "No categories found." },
    ...SECTION_STYLE_FIELDS,
  ],
};
